import React, { FC } from 'react'
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'

import { TRANSLATIONS as T } from '../../constants'
import { Typography, useTranslate } from '@dg-shared/index'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainerMain: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      height: '80px',
      borderRadius: '0 0 10px 10px',
      boxShadow: '0px 6px 15px rgba(13, 51, 32, 0.1)',
      backgroundColor: theme.palette.secondary.contrastText,
      justifyContent: 'space-between',
    },
    logoDesktopHeader: theme.brand.assets.images.logoDesktopHeader,
    disclaimer: {
      margin: 'auto 0',
    },
  })
)

const HeaderShared: FC = () => {
  const classes = useStyles()
  const { t } = useTranslate()

  return (
    <Grid container className={classes.gridContainerMain}>
      <Grid item xs={3} className={classes.logoDesktopHeader} />
      <Typography className={classes.disclaimer} type={'h4'}>
        {t(`${T.COMMON}/navBarDisclaimer`)}
      </Typography>
    </Grid>
  )
}

export default HeaderShared
